import { useState, useCallback } from "react";

interface SliderInputProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  label: string;
  required?: boolean;
}

export function SliderInput({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  label,
  required,
}: SliderInputProps) {
  const [textValue, setTextValue] = useState(String(value));

  const handleSlider = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const n = Number(e.target.value);
      onChange(n);
      setTextValue(String(n));
    },
    [onChange],
  );

  const handleText = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setTextValue(e.target.value);
      const n = Number(e.target.value);
      if (!isNaN(n)) {
        onChange(Math.min(max, Math.max(min, n)));
      }
    },
    [onChange, min, max],
  );

  const handleBlur = useCallback(() => {
    setTextValue(String(value));
  }, [value]);

  const pct = ((value - min) / (max - min)) * 100;

  return (
    <div>
      <label className="mb-1 block text-xs font-medium text-ink-2">
        {label}
        {required && <span className="ml-1 text-danger">*</span>}
      </label>
      <div className="flex items-center gap-3">
        <div className="relative flex-1">
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={handleSlider}
            className="w-full accent-accent"
          />
          <div className="mt-0.5 flex justify-between text-[10px] text-ink-3">
            <span>{min}</span>
            <span>{max}</span>
          </div>
        </div>
        <input
          type="text"
          value={textValue}
          onChange={handleText}
          onBlur={handleBlur}
          className="w-16 rounded-lg border border-line bg-surface px-2 py-1.5 text-center text-sm text-ink focus:border-line-strong focus:outline-none"
        />
      </div>
    </div>
  );
}
